import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'

const Navbar = () => {
    const state = useSelector(state => state.handleCart)
    const [showEnquiry, setShowEnquiry] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        contact: '',
        email: '',
        query: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            let message = formData.query
            if (formData.contact) {
                message += `\n\nContact Number: ${formData.contact}`
            }

            const response = await fetch('https://qlnluxi50c.execute-api.us-east-1.amazonaws.com/enquiry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    message: message,
                }),
            })

            if (response.ok) {
                toast.success('Enquiry sent successfully!')
                setShowEnquiry(false)
                setFormData({
                    name: '',
                    contact: '',
                    email: '',
                    query: '',
                })
            } else {
                throw new Error('Failed to send enquiry')
            }
        } catch (error) {
            console.error('Error sending enquiry:', error)
            toast.error('Failed to send enquiry. Please try again.')
        } finally {
            setIsSubmitting(false)
        }
    }
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 sticky-top">
            <div className="container d-flex align-items-center flex-wrap flex-lg-nowrap px-3 px-sm-4 justify-content-start">
                <NavLink className="navbar-brand d-flex align-items-center gap-2 text-dark flex-shrink-0 me-3" to="/">
                    <img
                        src="/assets/logo.png"
                        alt="Balvindra Instruments Corporation"
                        className="navbar-brand-img"
                        width={100}
                    />
                    <span className="fw-bold fs-4 d-none d-lg-inline">
                        Balvindra Instruments <br/>Corporation
                    </span>
                </NavLink>
                <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center gap-2 order-3 order-lg-3 cta-buttons navbar-cta-center">
                    <button
                        type="button"
                        className="btn btn-outline-dark m-0 fw-bold text-dark btn-enquiry-pulse cta-button"
                        onClick={() => setShowEnquiry(true)}
                    >
                        <i className="fa fa-edit mr-1"></i> Send Enquiry
                    </button>
                    <a href="tel:+919896310697" className="btn btn-outline-dark m-0 fw-bold text-dark cta-button">
                        <i className="fa fa-phone mr-1"></i> +91-9896310697
                    </a>
                </div>

                <button
                    className="navbar-toggler ms-auto order-4 d-lg-none ms-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse order-4 w-100" id="navbarSupportedContent">
                    <ul className="navbar-nav my-2 text-center text-lg-end ms-lg-auto">
                        <li className="nav-item">
                            <NavLink className="nav-link fw-bold" to="/">Home </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link fw-bold" to="/product">Products</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link fw-bold" to="/about">About</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link fw-bold" to="/contact">Contact</NavLink>
                        </li>
                    </ul>
                </div>

            </div>
            {showEnquiry && (
                <div className="enquiry-modal-backdrop" onClick={() => setShowEnquiry(false)}>
                    <div className="enquiry-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="enquiry-modal-header">
                            <h5 className="m-0">Send Enquiry</h5>
                            <button type="button" className="close" onClick={() => setShowEnquiry(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label className="mb-1">Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className="mb-1">Contact number</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    name="contact"
                                    value={formData.contact}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label className="mb-1">Email *</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className="mb-1">Query (min 10 characters) *</label>
                                <textarea
                                    className="form-control"
                                    name="query"
                                    rows="3"
                                    minLength={10}
                                    value={formData.query}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => setShowEnquiry(false)}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </nav>
    )
}

export default Navbar